import { render, staticRenderFns } from "./TicketDetails.view.vue?vue&type=template&id=3baa8a5c"
import script from "./TicketDetails.view.vue?vue&type=script&lang=js"
export * from "./TicketDetails.view.vue?vue&type=script&lang=js"
import style0 from "./TicketDetails.view.vue?vue&type=style&index=0&id=3baa8a5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports